// ------------------------------------------------------------------------------------------------------------------ //
//   ERROR HANDLER                                                                                                    //
// ------------------------------------------------------------------------------------------------------------------ //

import type { PrettyFn } from './types';
import { init } from './init';
import type { CreatePrettyLoggerOptions } from './factories';

export const pVue: PrettyFn = ($) => $('Vue', $.bold, $.italic);
export const pBold: (x: string) => PrettyFn = (x) => ($) => $(x, $.bold);

export function vueWarnHandler(msg: any, instance: any, trace: string) {
    const traceParts = trace.split('\n');
    console.pretty.warn`${pVue} ${($) =>
        $(traceParts[0], $.italic, $.xs)}${pBold(':')} ${msg}`();
}

export function vueErrorHandler(err: unknown, instance: unknown, info: string) {
    console.pretty.error`${pVue}${($) =>
        $.s('[', $.bold).s(info, $.italic, $.xs).s(']:', $.bold)} ${err}`();
}

export function vuePrettyConsole(
    app: any,
    options: CreatePrettyLoggerOptions = {}
) {
    init(options);
    app.config.globalProperties.$console = console;
    app.config.globalProperties.$log = console.log;
    app.config.warnHandler = vueWarnHandler;
    app.config.errorHandler = vueErrorHandler;
}
